export default [{
    name: 'dashboard',
    children: [{
        name: 'InsuranceList',
        path: '/insurance/list',
        component: resolve => require(['./list.vue'], resolve)
    }, {
        name: 'InsuranceThrowList',
        path: '/insurance/InsuranceThrow/throwList',
        component: resolve => require(['./InsuranceThrow/throwList.vue'], resolve)
    },{
        name: 'InsurancePolicyUpdate',
        path: '/insurance/InsurancePolicy/update',
        component: resolve => require(['./InsurancePolicy/update.vue'], resolve)
    },{
        name: 'InsuranceProductUpdate',
        path: '/insurance/InsuranceProduct/update',
        component: resolve => require(['./InsuranceProduct/update.vue'], resolve)
    }, {
        name: 'InsuranceThrowUpdate',
        path: '/insurance/InsuranceThrow/update',
        component: resolve => require(['./InsuranceThrow/update.vue'], resolve)
    }, {
        name: 'InsuranceRobotInfoDetail',
        path: '/insurance/robotInfo/detail',
        component: resolve => require(['./InsuranceRobot/detail.vue'], resolve)
    }, {
        path: '/Invisible/Invisible/list',
        component: resolve => require(['../Invisible/Index.vue'], resolve)
    },{
        name:'analyseList',
        path: '/analyse/list',
        component: resolve => require(['../Invisible/analyse.vue'], resolve)
    },{
        path: '/analyse/log',
        component: resolve => require(['../Invisible/modules/log.vue'], resolve)
    }],
}]



// WEBPACK FOOTER //
// ./src/views/insurance/router.js